export function generateImageUrl(id: string) {
	return `https://tokens.defiplaza.net/cdn-cgi/imagedelivery/QTzOBjs3mHq3EhZxDosDSw/${id}/token`;
}